// pages/GrazeBoxes/GrazeBoxDetails/SizeSelector.jsx
import React from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const SizeSelector = ({ selectedSize, setSize, sizes }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (_, newSizeId) => {
    if (!newSizeId) return;
    const found = sizes.find((s) => s.sizeId === newSizeId);
    if (found) setSize(found);
  };

  const currentValue = selectedSize?.sizeId || null;

  return (
    <Box sx={{ mt: 4, mb: 3 }}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Size: {selectedSize?.name || "—"}
      </Typography>

      <ToggleButtonGroup
        value={currentValue} // 👈 stable string
        exclusive
        onChange={handleChange}
        fullWidth={isMobile}
        sx={{ flexWrap: "wrap" }}>
        {sizes.map((s) => (
          <ToggleButton
            key={s.sizeId}
            value={s.sizeId} // 👈 stable string
            sx={{ textTransform: "capitalize", flex: isMobile ? 1 : "none" }}>
            <Box textAlign="center">
              <Typography>{s.name}</Typography>
              <Typography variant="caption" sx={{ fontSize: 11 }}>
                Serves up to {s.servesUpTo}
              </Typography>
            </Box>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default SizeSelector;
